import * as React from "react";

const SvgComponent = ({
  color = "#fff",
  bg = "#fff",
  width = 25,
  height = 25,
  ...props
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 100 100"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    {...props}
  >
    {/* Battery */}
    <path
      d="M10 38H18"
      stroke={color}
      strokeWidth={3}
      strokeLinecap="round"
      fill={bg}
    />

    <path
      d="M10 38C7.8 38 6 39.8 6 42V82C6 84.2 7.8 86 10 86H84C86.2 86 88 84.2 88 82V42C88 39.8 86.2 38 84 38H73"
      stroke={color}
      strokeWidth={3}
      strokeLinecap="round"
      strokeLinejoin="round"
      fill={bg}
    />

    {/* Battery terminal */}
    <path
      d="M88 50H93C95.2 50 97 51.8 97 54V70C97 72.2 95.2 74 93 74H88"
      stroke={color}
      strokeWidth={3}
      strokeLinecap="round"
      strokeLinejoin="round"
      fill={bg}
    />

    {/* Leaf */}
    <path
      d="M31 78C31 78 30 59 39 42C46 29 57 20 66 17C68 30 65 43 58 53C51 63 41 70 31 78Z"
      stroke={color}
      strokeWidth={3}
      strokeLinecap="round"
      strokeLinejoin="round"
      fill={bg}
    />

    {/* Leaf vein */}
    <path
      d="M31 78C37 62 46 48 59 34"
      stroke={color}
      strokeWidth={2}
      strokeLinecap="round"
    />
  </svg>
);

export default SvgComponent;